export default __webpack_public_path__ + "static/media/1.246c78ae.png";